import React from 'react'
import './AboutUs.css'
import { translation } from 'assets/translations/translations'

type Props = {
  language: string
}

const AboutUs = ({ language }: Props) => {
  return (
    <section className='about-us-main'>
      <div className='about-us-shell'>
        <span className='about-us-kicker'>ILE Soft</span>
        <h2 className='about-us-title'>
          {translation(language, 'aboutUsTitle')}
        </h2>
        <div className='about-us-text'>
          {translation(language, 'aboutUsText')}
        </div>
      </div>
    </section>
  )
}

export default AboutUs